import axiosInstance from '../axiosInterceptor/axiosInstance'

// Trigger a manual external-CMS refresh for a synced season. The backend enqueues a
// background job (syncs the season structure, then the next few days of games) and
// responds 202 Accepted immediately — there is no payload to return.
const refreshSeasonSync = async (orgId, seasonId) => {
  const url = `v1/orgs/${orgId}/seasons/${seasonId}/cms-sync`
  const response = await axiosInstance.post(url)
  return response?.data
}

export default refreshSeasonSync
